export default "__VITE_ASSET__DEIqSc5f__"